import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import _ from 'lodash';

const State = new Record({
    selectedEvent: null,
    columns: null,
    events: null,
});

function getSelectedEvent(events) {
    if (!events)
        return null;

    return _.find(events, function (event) {
        return event.selected;
    });
}

class PresencaStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.SELECT_EVENTS_FINISH:
                return state
                    .set('events', action.events)
                    .set('selectedEvent', getSelectedEvent(action.events));

            case ActionTypes.SELECT_ATTENDANCE_COLUMNS_FINISH:
                let columns = action.columns;
                let total = columns.total;
                let value = [];
                for (let i = 0; i < total; i++)
                    value.push(columns['column_' + i]);

                return state
                    .set('columns', value);

            default:
                return state;
        }
    }
}

export default new PresencaStore();




// WEBPACK FOOTER //
// src/stores/PresencaStore.js